import AllFinishedFightsApp from "./AllFinishedFightsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(AllFinishedFightsApp);
